<template>
    <div>
        <div :id="modalId" class="modal fade" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
            <div :class="'modal-dialog modal-dialog-centered modal-' + size">
                <div class="modal-content">
                    <div v-if="!hideHeader" class="modal-header pb-0" :class="headerClass">
                        <slot name="header">
                            <h4 v-if="title" class="pt-1">{{ title }}</h4>
                        </slot>
                        <span v-if="showClose" :title="$t('Nav.close')" class="mt-n2" @click="close">
                            <i class="fa-solid fa-xmark"></i>
                        </span>
                    </div>
                    <div class="modal-body">
                        <a
                            v-if="hideHeader && showClose"
                            href="javascript:void(0);"
                            style="position: absolute; top: 20px; right: 20px; opacity: 1;"
                            class="btn-close"
                            @click="close"
                        ></a>
                        <slot></slot>
                    </div>
                    <div v-if="!hideFooter" class="modal-footer">
                        <slot name="footer"></slot>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { Modal } from 'bootstrap';
export default {
    name: 'Modal',
    props: {
        show: {
            type: Boolean,
            default: false
        },
        hideFooter: {
            type: Boolean,
            default: true
        },
        hideHeader: {
            type: Boolean,
            default: true
        },
        size: {
            type: String,
            default: 'lg'
        },
        showClose: {
            type: Boolean,
            default: true
        },
        closeOnEsc: {
            type: Boolean,
            default: false
        },
        closeOnBackdrop: {
            type: Boolean,
            default: false
        },
        title: {
            type: String,
            default: null
        },
        optionBackdrop: {
            type: String,
            default: null
        },
    },
    data() {
        return {
            modal: null,
            modalId: (Math.random() + 1).toString(36).substring(3),
        };
    },
    computed: {
        headerClass() {
            if (this.title && this.showClose) {
                return 'd-flex justify-content-between';
            } else if (!this.title && this.showClose) {
                return 'd-flex justify-content-end';
            }
            return '';
        },
    },
    watch: {
        show(newVal) {
            return newVal ? this.modal.show() : this.modal.hide();
        },
    },
    mounted() {
        let options = {
            keyboard: this.closeOnEsc,
            backdrop: this.closeOnBackdrop ? true : 'static'
        };
        if (this.optionBackdrop) options.backdrop = this.optionBackdrop;
        this.modal = new Modal(document.getElementById(this.modalId), options);
        document.getElementById(this.modalId).addEventListener('hidden.bs.modal', () => {
            this.close();
        });
    },
    methods: {
        close() {
            this.$emit('update:show', false);
        },
    },
};
</script>
<style scoped></style>